// extracted by mini-css-extract-plugin
module.exports = {"attributes-no-content":"attributes-list_attributes-no-content__qLJRi","attributes-list":"attributes-list_attributes-list__1zH1P"};